// @ts-nocheck

import { __ } from '../../../i18n/l10n';
import { selectEntitiesMatchesEntity } from '../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { selectMatchTimeInSeconds } from '../../../selectors/match.selector';
import { type StateType } from '../../../states';
import { MatchEntity, MatchEntityStatus } from '../../../states/entities/matches';

// for grids, when overtime, match is considered closed
export const isLiveIsOvertime = (state: StateType, matchId: number) => {
  const seconds = selectMatchTimeInSeconds(state, { matchId });
  return seconds ? seconds > 90 * 60 : false; // en seconds
};

export const getMatchHelpInfos = (state: StateType, { matchId }: { matchId: number }) => {
  const match = selectEntitiesMatchesEntity(state, { matchId });

  if (match) {
    const { matchStart, odds1, oddsX, odds2, competitor1Name, competitor2Name } = match;

    const mainBetOutcomes = [
      { label: competitor1Name, value: odds1 },
      { label: __('Draw'), value: oddsX },
      { label: competitor2Name, value: odds2 },
    ];

    return {
      competitor1Name,
      competitor2Name,
      matchStart,
      mainBetOutcomes,
    };
  }
  return {};
};

export const getMatchGridLineInfos = (state: StateType, { matchId }: { matchId: number }) => {
  const match = selectEntitiesMatchesEntity(state, { matchId });

  return {
    matchStatus: match?.status,
    score1: match?.regularScore1,
    score2: match?.regularScore2,
    matchStart: match?.matchStart,
    isCancelled: MatchEntity.isGridCancelled(match),
    isLive: MatchEntityStatus.isLive(match?.status) && !isLiveIsOvertime(state, matchId),
    isEnded: MatchEntityStatus.isEnded(match?.status) || isLiveIsOvertime(state, matchId),
    isPrematch: MatchEntityStatus.isPrematch(match?.status),
  };
};
